/**
 * @desc 海关要素-列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CustomsInfoResponseDto>>;
export function request(
  params: API.basics.customsInfo.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
